// extracted by mini-css-extract-plugin
export default {"legalPageContainer":"Legal_legalPageContainer__q2X39","link":"Legal_link__APTH6"};